export default "__VITE_ASSET__BPu7Qy7a__"